module.exports = __webpack_public_path__ + "static/media/icon_wifi-warning.f0f1527a.svg";